import { Component, OnInit } from '@angular/core';
import { DisplayMode, SingleStoreModalComponent } from '../single-store-modal/single-store-modal.component';
import { map } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { Validators } from '@angular/forms';
import { ModalService } from 'services';
import { StoreSelectorService } from 'app/b2b-order/services/store-selector/store-selector.service';
import { FcpModalService } from 'fc-ui-components';
import { StoreService } from 'app/b2b-order/services/store.service';
import { ShoppingCartService } from 'app/b2b-order/services/shopping-cart';

@Component({
    selector: 'fc-choose-single-store-for-copying-modal',
    templateUrl: '../single-store-modal/single-store-modal.component.html',
    styleUrls: ['../single-store-modal/single-store-modal.component.less'],
    standalone: false
})
export class SingleStoreModalForCopyingComponent extends SingleStoreModalComponent implements OnInit {
    modalTitle = 'ORDER.SHOPPING_CART.COPY_TO';
    isMulti = true;

    constructor(
        public fcpModalService: FcpModalService,
        public storeService: StoreService,
        public storeSelectorService: StoreSelectorService,
        public modalService: ModalService,
        private shoppingCartService: ShoppingCartService
    ) {
        super(fcpModalService, storeService, storeSelectorService, modalService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.stores = combineLatest([
            this.storeService.storeDropdown,
            this.shoppingCartService.sourceStoreIdForCopying,
            this.storeSelectorService.selectedStores
        ]).pipe(
            map(([stores, currentStoreIdForCopying, selectedStores]) =>
                stores.filter(
                    (store) =>
                        store.value._id !== currentStoreIdForCopying &&
                        selectedStores.findIndex((selectedStore) => selectedStore._id === store.value._id) !== -1
                )
            )
        );
        this.selectStoreForm.controls.stores.addValidators(Validators.required);
    }

    public get modalSize() {
        return this.displayMode === DisplayMode.Desktop ? 'medium' : 'mobile';
    }

    emitSelectedStore() {
        if (this.selectStoreForm.invalid) {
            this.selectStoreForm.controls.stores.markAsDirty();
            return;
        }
        const stores = this.selectStoreForm.get('stores').value;
        const storeIds = stores.map((store) => store.value._id);
        this.shoppingCartService.setTargetStoreIdForCopying(storeIds);
        this.selectStoreForm.controls.stores.markAsPristine();
        this.hideModal();
    }

    public get storeDropdownInvalid() {
        return this.selectStoreForm.controls.stores.dirty && this.selectStoreForm.controls.stores.invalid;
    }
}

export const selectStoreForCopyingModalId = 'select-store-for-copying';
